import { useOverlays } from "contexts/OverlayContext";
import { BankCashItemType } from "@common/types/bankCashItem";
import { PlainModal } from "@design-system/Modal/Modal";
import { RecordCheckModal } from "./RecordCheckModal";

const OVERLAY_BY_TYPE = {
    [BankCashItemType.CHECK]: "recordCheck",
    [BankCashItemType.DEPOSIT]: "recordDeposit",
} as const satisfies Record<BankCashItemType, "recordCheck" | "recordDeposit">;

const CashItemModalContainer = ({ type }: { type: BankCashItemType }) => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo(OVERLAY_BY_TYPE[type]);

    if (!overlayInfo) {
        return null;
    }

    return (
        <PlainModal show={!overlayIsClosing} onHide={closeOverlay} size="xl">
            <RecordCheckModal
                key={overlayInfo.instanceId}
                type={type}
                onHide={closeOverlay}
                initialFinancialAccountId={overlayInfo.data?.financialAccountId}
            />
        </PlainModal>
    );
};

export const RecordCheckModalContainer = () => (
    <CashItemModalContainer type={BankCashItemType.CHECK} />
);

export const RecordDepositModalContainer = () => (
    <CashItemModalContainer type={BankCashItemType.DEPOSIT} />
);
